import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import ContactForm from '../components/ContactForm';
import { Card, CardContent } from '../components/ui/card';
import { Toaster } from '../components/ui/toaster';

const Contact = () => {
  const contactInfo = [
    {
      icon: MapPin,
      title: 'Office Address',
      details: ['765 Market St APT 34D', 'San Francisco, CA 94103', 'United States']
    },
    {
      icon: Phone,
      title: 'Phone',
      details: ['Main: +1 (833) 201-7487', 'Support: +1 (833) 201-7487', 'Toll-Free: +1 (833) 201-7487']
    },
    {
      icon: Mail,
      title: 'Email',
      details: ['General: info@trademarkvector.com', 'Support: support@trademarkvector.com', 'Legal: legal@trademarkvector.com']
    },
    {
      icon: Clock,
      title: 'Business Hours',
      details: ['Monday - Friday: 9:00 AM - 6:00 PM', 'Saturday: 10:00 AM - 4:00 PM', 'Sunday: Closed']
    }
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-[#2C3E50] to-[#34495E] relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#C0392B]/20 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/5 rounded-full blur-3xl" />
        
        <div className="container mx-auto px-4 max-w-[1320px] relative z-10">
          <div className="max-w-4xl mx-auto text-center space-y-6">
            <h1 className="text-5xl md:text-6xl font-bold text-white">
              Get in <span className="text-[#C0392B] underline decoration-[#C0392B]/50">Touch</span>
            </h1>
            <p className="text-xl text-white/80 leading-relaxed">
              Have questions about our trademark services? Our expert team is here to help. 
              Reach out today and let's protect your brand together.
            </p>
          </div>
        </div>
      </section>

      {/* Content wrapper with flex for mobile reordering */}
      <div className="flex flex-col">
        {/* Contact Form - Shows First on Mobile */}
        <section className="py-20 bg-gradient-to-br from-[#C0392B] to-[#A93226] relative overflow-hidden order-1 md:order-2">
        {/* Decorative elements */}
        <div className="absolute top-10 right-10 w-72 h-72 bg-white/5 rounded-full blur-3xl" />
        <div className="absolute bottom-10 left-10 w-72 h-72 bg-white/5 rounded-full blur-3xl" />
        
        <div className="container mx-auto px-4 max-w-[1320px] relative z-10">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12 space-y-4">
              <h2 className="text-4xl md:text-5xl font-bold text-white">
                Send Us a Message
              </h2>
              <p className="text-xl text-white/90">
                Fill out the form and we'll get back to you within 24 hours
              </p>
            </div>
            
            <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 border-2 border-white/20">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info Cards - Shows After Form on Mobile */}
      <section className="py-12 bg-gradient-to-br from-white via-[#FDFEFE] to-white relative overflow-hidden order-2 md:order-1">
        {/* Decorative blobs */}
        <div className="absolute top-0 right-1/4 w-64 h-64 bg-[#C0392B]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-1/4 w-64 h-64 bg-[#7F8C8D]/5 rounded-full blur-3xl" />
        
        <div className="container mx-auto px-4 max-w-[1320px] relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {contactInfo.map((info, index) => {
              const Icon = info.icon;
              return (
                <Card key={index} className="border-[#7F8C8D]/20 hover:border-[#C0392B]/50 hover:shadow-lg transition-all duration-300">
                  <CardContent className="p-6">
                    <div className="flex flex-col items-center text-center space-y-4">
                      <div className="w-16 h-16 bg-[#C0392B]/10 rounded-2xl flex items-center justify-center">
                        <Icon className="w-8 h-8 text-[#C0392B]" />
                      </div>
                      <h3 className="text-lg font-bold text-[#2C3E50]">{info.title}</h3>
                      <div className="space-y-1">
                        {info.details.map((detail, idx) => (
                          <p key={idx} className="text-sm text-[#2C3E50]">{detail}</p>
                        ))}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>
      </div>

      <Toaster />
    </div>
  );
};

export default Contact;